/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUrlParameter } from "../functions/get-url-parameter.js";

const __vue_script__ = {
  computed: {
    isTrial() {
      return window.plan && window.plan.is_trial;
    },
    hasCard() {
      return product.payment_methods.includes('credit_card') || product.payment_methods.includes('card_pix');
    },
    hasBillet() {
      return !getUrlParameter('hideBillet') && !window.is_foreign && product.payment_methods.includes('billet') && !this.isTrial;
    },
    hasPix() {
      return !getUrlParameter('hidePix') && !window.is_foreign && (product.payment_methods.includes('pix') || product.payment_methods.includes('card_pix'))&& !this.isTrial;
    }
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-type-logos" },
    [
      _vm.hasCard
        ? [
            _c("img", {
              attrs: { src: "/static/images/payment-methods/card-1.png" },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/static/images/payment-methods/card-2.png" },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/static/images/payment-methods/card-3.png" },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/static/images/payment-methods/card-4.png" },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/static/images/payment-methods/card-5.png" },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/static/images/payment-methods/card-6.png" },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/static/images/payment-methods/card-7.png" },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasBillet
        ? _c("img", {
            attrs: { src: "/static/images/payment-methods/billet.png" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPix
        ? _c("img", {
            attrs: { src: "/static/images/payment-methods/pix.png" },
          })
        : _vm._e(),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-37a59d40_0", { source: ".payment-type-logos {\n  display: flex;\n  justify-content: center;\n  margin: -4px 0;\n  flex-wrap: wrap;\n}\n.payment-type-logos img {\n  margin: 4px 4px;\n}\n\n/*# sourceMappingURL=payment-type-logos.vue.map */", map: {"version":3,"sources":["frontend/components/payment-type-logos.vue","payment-type-logos.vue"],"names":[],"mappings":"AAsCA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;ACrCA;ADuCA;EACA,eAAA;ACrCA;;AAEA,iDAAiD","file":"payment-type-logos.vue","sourcesContent":["<template>\n  <div class=\"payment-type-logos\">\n    <template v-if=\"hasCard\">\n      <img src=\"/static/images/payment-methods/card-1.png\" />\n      <img src=\"/static/images/payment-methods/card-2.png\" />\n      <img src=\"/static/images/payment-methods/card-3.png\" />\n      <img src=\"/static/images/payment-methods/card-4.png\" />\n      <img src=\"/static/images/payment-methods/card-5.png\" />\n      <img src=\"/static/images/payment-methods/card-6.png\" />\n      <img src=\"/static/images/payment-methods/card-7.png\" />\n    </template>\n    <img v-if=\"hasBillet\" src=\"/static/images/payment-methods/billet.png\" />\n    <img v-if=\"hasPix\" src=\"/static/images/payment-methods/pix.png\" />\n  </div>\n</template>\n\n<script>\nimport { getUrlParameter } from \"../functions/get-url-parameter.js\";\n\nexport default {\n  computed: {\n    isTrial() {\n      return window.plan && window.plan.is_trial;\n    },\n    hasCard() {\n      return product.payment_methods.includes('credit_card') || product.payment_methods.includes('card_pix');\n    },\n    hasBillet() {\n      return !getUrlParameter('hideBillet') && !window.is_foreign && product.payment_methods.includes('billet') && !this.isTrial;\n    },\n    hasPix() {\n      return !getUrlParameter('hidePix') && !window.is_foreign && (product.payment_methods.includes('pix') || product.payment_methods.includes('card_pix'))&& !this.isTrial;\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\">\n.payment-type-logos {\n  display: flex;\n  justify-content: center;\n  margin: -4px 0;\n  flex-wrap: wrap;\n\n  img {\n    margin: 4px 4px;\n  }\n}\n</style>",".payment-type-logos {\n  display: flex;\n  justify-content: center;\n  margin: -4px 0;\n  flex-wrap: wrap;\n}\n.payment-type-logos img {\n  margin: 4px 4px;\n}\n\n/*# sourceMappingURL=payment-type-logos.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/payment-type-logos.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__